import React from "react";
import Button from "@mui/material/Button";

const CustomStepper = ({items}) => {
    return (
        <div className="stepper">
            {items.map((item, index) => (
                <div className={"step"} key={index}>
                    <div className={"step-header"}>
                        <div className={"step-logo"}>
                            <img src={item?.iconUrl} alt={item?.title} loading={"lazy"} />
                        </div>
                        <h3 className={"step-title"}>{item?.title}</h3>
                    </div>
                    <div className={"step-content-wrapper"}>
                        <div className={"step-content"}>
                            <div
                                className="step-description"
                                dangerouslySetInnerHTML={{__html: item?.description}}
                            />
                            {item?.ctaUrl && (
                                <div className="step-action">
                                    <Button
                                        className={"button hover-move"}
                                        variant="contained"
                                        href={item?.ctaUrl}
                                        target={"_blank"}
                                        rel="noreferrer"
                                        onClick={() => window.umami?.track("Partner Click", { label: item?.title })}
                                    >
                                        {item?.ctaText}
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default CustomStepper;
